import { render } from "./DsHome.vue?vue&type=template&id=794c700e"
import script from "./DsHome.vue?vue&type=script&lang=js"
export * from "./DsHome.vue?vue&type=script&lang=js"

import "./home.css?vue&type=style&index=0&lang=css&external"

import exportComponent from "../../../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.41_vue@3.5.41_webpack@5.109.2/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__